import { useAuth } from '~lib/authProvider'
import { routes } from '~constants/routes'

import { BorkHead } from '~assets/BorkHead'
import { ProcuritPurple } from '~assets/ProcuritPurple'
export const Navbar = () => {
  const { authLogout } = useAuth()

  return (
    <header className="bg-white p-6 sm:px-6 lg:px-8 h-24 border-b-2 border-t-4 border-t-primary">
      <nav className="mx-auto max-w-8xl flex items-center justify-between">
        <a href={routes.dashboard} className="h-10 flex gap-x-3 items-center">
          <div className="h-14 w-14">
            <BorkHead />
          </div>
          <div className="w-36 h-10">
            <ProcuritPurple />
          </div>
        </a>

        <div className="flex items-center justify-start md:ml-6 gap-12 mr-8">
          <a
            href={routes.dashboard}
            className="text-black text-sm font-medium hidden sm:block"
          >
            Requests
          </a>
          <a
            href="#"
            className="text-black text-sm font-medium"
            onClick={authLogout}
          >
            Log out
          </a>
        </div>
      </nav>
    </header>
  )
}
